import { Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SharedConditionProps } from '../../types';
import { ComparatorSelect } from '../components/ComparatorSelect';
import { InputField } from '../InputField';
import { messages } from './messages';
import useStyles from './styles';

export const AssessmentFormScoreResult: FC<SharedConditionProps> = ({
  condition,
  ruleId,
  setRules,
  errors,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <Grid item xs={12} className={classes.scoreScaleHint}>
        <Alert severity="info">
          <FormattedMessage {...messages.scoreScaleHint} />
        </Alert>
      </Grid>
      <ComparatorSelect
        setRules={setRules}
        ruleId={ruleId}
        condition={condition}
        errors={errors}
        onlyReturnBasicComparators
      />
      <Grid item xs={6}>
        <InputField
          condition={condition}
          ruleId={ruleId}
          setRules={setRules}
          errors={errors}
          valueKey="score"
          inputType="number"
          placeholder={intl.formatMessage(messages.scoreInputPlaceholder)}
        />
      </Grid>
    </>
  );
};
